import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {  useSelector } from "react-redux";
import { deleteMaquilero } from "../functions";
const MaquileroDelete = ({openDelete,setOpenDelete}) => {
    const { maquileroIdSelected } = useSelector(({ maquilero }) => maquilero);
    
    const deleteFnc = async () =>{
    await deleteMaquilero(maquileroIdSelected)
    setOpenDelete(false);
}
    return (
        <>
            <Dialog
            open={openDelete}
            onClose={()=>setOpenDelete(false)}
            >
                <DialogTitle>
                    <Typography variant="title">{"Eliminar"}</Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="subtitle">
                        {"Continuar con la Eliminacion del Maquilero"}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>setOpenDelete(false)} color="primary"
                    >
                        Cancelar
                    </Button>
                    <Button onClick={deleteFnc} color="primary" >
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default MaquileroDelete;